var map = {
	"./Relevo-GLASS_Rückgabeschild_A4_LEER_MI.png": 92890,
	"./Relevo-GLAS_Rückgabeschild_A4_LEER.png": 72160,
	"./Relevo-KLASSIK_Rückgabeschild_A4_LEER.png": 66471,
	"./Relevo-KLASSIK_Rückgabeschild_A4_LEER_MI.png": 20102,
	"./green-check-mark.png": 41323,
	"./logo.png": 82806,
	"./news.png": 12782,
	"./retterRelevosBackground.png": 42575,
	"./ruckgabe.png": 27797,
	"./select_quantities_placeholder.png": 12585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;